import React, { useEffect, useRef, useState } from "react";
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../tvapk.css';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import { createTvApk, updateTvApk, getTvApkByID } from "../../../../Services/TvApksService/TvApkService";

const tvApkOptions = [
  { label: "MM PRIMARY", value: "mm_primary" },
  { label: "MM ONE", value: "mm_one" },
  { label: "MM SMART", value: "mm_smart" },
  { label: "MM KIDS", value: "mm_kidz" },
];

const CreateEditTvApk = ({ isShow, close, type, tvApkId, projectId }) => {
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [tvApkName, setTvApkName] = useState("");
  const [tvAppId, setTvAppId] = useState("");
  const [tvApkNameError, setTvApkNameError] = useState(false);
  const [tvAppIdError, setTvAppIdError] = useState(false);
  const tvApkNameRef = useRef(null);
  const tvAppIdRef = useRef(null);

  useEffect(() => {
    setShow(isShow);

    if (!isShow) {
      setTvApkName("");
      setTvAppId("");
      setTvApkNameError(false);
      setTvAppIdError(false);
      return;
    }

    if (type === "EDIT" && tvApkId) {
      fetchTvApkDetails();
    } else {
      setTvApkName("");
      setTvAppId("");
      setTvApkNameError(false);
      setTvAppIdError(false);
    }
  }, [isShow, type, tvApkId]);

  const fetchTvApkDetails = async () => {
    try {
      const response = await getTvApkByID(tvApkId);
      if (response?.status) {
        const matchedOption = tvApkOptions.find((option) => option.value === (response.data.app_id || ""));
        setTvApkName(matchedOption ? matchedOption.label : response.data.name || "");
        setTvAppId(response.data.app_id || "");
      } else {
        toast.error("Failed to fetch tvapk details");
      }
    } catch (error) {
      console.error("Error fetching tvapk details:", error);
    }
  };

  const handleNameChange = (e) => {
    const selectedValue = e.target.value;
    const selectedOption = tvApkOptions.find((option) => option.value === selectedValue);

    setTvApkName(selectedOption ? selectedOption.label : "");
    setTvAppId(selectedOption ? selectedOption.value : "");

    if (tvApkNameError && selectedValue) {
      setTvApkNameError(false);
    }
    if (tvAppIdError && selectedValue) {
      setTvAppIdError(false);
    }
  };

  const handleNameKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    if (!tvApkName.trim() || !tvAppId.trim()) {
      setTvApkNameError(!tvApkName.trim());
      setTvAppIdError(!tvAppId.trim());

      if (tvApkNameRef.current) {
        tvApkNameRef.current.focus();
      }
      return;
    }

    setIsLoading(true);
    setIsDisabled(true);

    const payload = {
      name: tvApkName.trim(),
      app_id: tvAppId.trim(),
      project_id: projectId,
    };
    try {
      let response;
      if (type === "CREATE") {
        response = await createTvApk(payload);
      } else {
        payload.id = tvApkId;
        response = await updateTvApk(payload);
      }

      if (response.status) {
        toast.success(response.message);
        close();
      } else {
        toast.error(response.errorMessage);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
      setIsDisabled(false);
    }
  };

  return (
    <Modal show={show} onHide={() => close(false)}>
      <Modal.Header closeButton>
        <h5 className="modal-title">{type === "CREATE" ? "Add TvApk" : "Edit TvApk"}</h5>
      </Modal.Header>
      <Modal.Body>
        <form className="row g-3" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
          <div className="col-12 px-3">
            <label htmlFor="tvApkName" className="form-label required">Name</label>
            <Form.Select
              id='tvApkName'
              ref={tvApkNameRef}
              value={tvAppId}
              onChange={handleNameChange}
              onKeyDown={handleNameKeyDown}
              className="form-control"
            >
              <option disabled value="">Select TvApk Name</option>
              {tvApkOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid" style={{ display: tvApkNameError ? 'block' : 'none' }}>
              TvApk name is required
            </Form.Control.Feedback>
          </div>
          <div className="col-12 px-3">
            <label htmlFor="tvAppId" className="form-label required">App ID</label>
            <input
              id='tvAppId'
              ref={tvAppIdRef}
              value={tvAppId}
              type="text"
              className="form-control"
              placeholder="Selected TvApp ID"
              disabled
              readOnly
            />
            <Form.Control.Feedback type="invalid" style={{ display: tvAppIdError ? 'block' : 'none' }}>
              TvApp ID is required
            </Form.Control.Feedback>
          </div>

          {isLoading && <div className="progress-bar"></div>}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
              onClick={() => close(false)}
            >
              Close
            </button>
            <button
              disabled={isDisabled}
              type="submit"
              className="btn btn-primary"
            >
              {type === "CREATE" ? "Save" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateEditTvApk;
